import { useEffect, useRef, useState } from 'react'
import { useT } from '@/lib/i18n'
import { VoiceRingArc } from './VoiceRingArc'
import { useVoiceRing } from './useVoiceRing'

/**
 * The ring around Emma, in the phone's tab bar and on the computer
 * (voice-ring.js rings()): it fills as the voice grows and glows for a moment
 * when it grows. Full, it turns pale amber and stays.
 */
export function EmmaVoiceRing() {
  const t = useT()
  const { ready, progress } = useVoiceRing()
  const [grow, setGrow] = useState(false)
  const last = useRef<number | null>(null)
  useEffect(() => {
    if (!ready) return
    if (last.current != null && progress.n > last.current) {
      setGrow(true)
      const id = window.setTimeout(() => setGrow(false), 1400)
      last.current = progress.n
      return () => window.clearTimeout(id)
    }
    last.current = progress.n
  }, [ready, progress.n])
  if (!ready || !progress.total) return null
  return (
    <span className={`vr-ring${progress.full ? ' is-full' : ''}${grow ? ' is-grow' : ''}`}
      title={progress.full ? t('voice.ringFull') : t('voice.ringTitle', { left: progress.left, total: progress.total })}>
      <VoiceRingArc pct={progress.pct} />
    </span>
  )
}
